<template>
  <b-card class="create-branch-form">
    <h5 class="mb-4">
      <i class="fas fa-code-branch mr-2 text-info"></i>
      Create New Branch
    </h5>
    <b-form @submit.prevent="handleSubmit">
      <ClinicSearchSelect
        v-model="selectedClinic"
        label="Select Clinic *"
        :state="$v.selectedClinic.$dirty ? !$v.selectedClinic.$error : null"
      />
      <b-form-invalid-feedback :state="!$v.selectedClinic.$error">
        Please select a clinic
      </b-form-invalid-feedback>
      <UserSearchSelect
        v-model="selectedUser"
        label="Select User to Link *"
        :state="$v.selectedUser.$dirty ? !$v.selectedUser.$error : null"
        class="mt-3"
      />
      <b-form-invalid-feedback :state="!$v.selectedUser.$error">
        Please select a user
      </b-form-invalid-feedback>
      <ExcelFileUploader
        v-model="file"
        label="Upload Excel File *"
        :state="$v.file.$dirty ? !$v.file.$error : null"
        class="mt-3"
      />
      <b-form-invalid-feedback :state="!$v.file.$error">
        Excel file is required
      </b-form-invalid-feedback>
      <b-form-group class="mt-3">
        <b-form-checkbox v-model="nhsoEnabled">
          <i class="fas fa-shield-alt mr-1"></i>
          Enable NHSO Integration
        </b-form-checkbox>
      </b-form-group>
      <b-button type="submit" variant="info" :disabled="loading" block>
        <i class="fas mr-2" :class="loading ? 'fa-spinner fa-spin' : 'fa-plus-circle'"></i>
        {{ loading ? 'Creating Branch...' : 'Create Branch' }}
      </b-button>
    </b-form>
  </b-card>
</template>

<script>
import { required } from 'vuelidate/lib/validators';
import { mapGetters, mapActions } from 'vuex';
import ExcelFileUploader from './ExcelFileUploader.vue';
import ClinicSearchSelect from './ClinicSearchSelect.vue';
import UserSearchSelect from './UserSearchSelect.vue';

export default {
  name: 'CreateBranchForm',
  components: { ExcelFileUploader, ClinicSearchSelect, UserSearchSelect },
  data() {
    return {
      selectedClinic: null,
      selectedUser: null,
      file: null,
      nhsoEnabled: false
    };
  },
  validations: {
    selectedClinic: { required },
    selectedUser: { required },
    file: { required }
  },
  computed: {
    ...mapGetters('moduleSuperadmin', ['isCreateBranchLoading']),
    loading() {
      return this.isCreateBranchLoading;
    }
  },
  methods: {
    ...mapActions('moduleSuperadmin', ['createBranch']),
    async handleSubmit() {
      this.$v.$touch();
      if (this.$v.$invalid) return;
      const formData = new FormData();
      formData.append('file', this.file);
      formData.append('clinicId', Number(this.selectedClinic.clinicId || this.selectedClinic.id));
      formData.append('uid', Number(this.selectedUser.uid));
      formData.append('nhso', this.nhsoEnabled);
      try {
        const result = await this.createBranch(formData);
        this.$emit('success', result.data);
        this.resetForm();
      } catch (error) {
        const message = error.response?.data?.error || 'Failed to create branch';
        this.$bvToast.toast(message, {
          title: 'Error',
          variant: 'danger',
          autoHideDelay: 5000
        });
      }
    },
    resetForm() {
      this.selectedClinic = null;
      this.selectedUser = null;
      this.file = null;
      this.nhsoEnabled = false;
      this.$v.$reset();
    }
  }
};
</script>
